import React from 'react'
import { API } from 'javascripts/api'

// ログアウトAPIを呼び出してトップにリダイレクトする
// ex: <a href="/" onClick={useMemberLogout()}>ログアウト</a>
const useMemberLogout = () => {
  const handleLogout = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault()

    // ログイン状態はサーバー側のセッションが正のため、APIが失敗した場合も遷移させて実際の状態を反映させる
    void API.userLogout()
      .catch((error: unknown) => {
        console.error('Failed to logout', error)
      })
      .finally(() => { location.href = '/' })
  }

  return handleLogout
}

export { useMemberLogout }
